import {OverrideAbstractViewModel, template as tpl, TemplatePlaceholder, templateTooltip} from "./Abstract";
import {IMoreStatus, IParams, IStatus} from "./index";
import {EMPTY_STRING} from "../../constants/Language";
import {lm} from "../../appContext";
import {nsOverride} from './nsOverride';
import syncfieldHtml from './syncfield.html?raw';

const tooltip = templateTooltip + syncfieldHtml
export let template = tpl.replace(TemplatePlaceholder, tooltip);

type TStatus = 'restore' | 'synced' | 'notsynced';

export class viewModel extends OverrideAbstractViewModel {
    private valueCssClass: string | null;

    constructor(params: IParams) {
        super(params);
        this.valueCssClass = this.override.value == '' ? 'text-warning' : null;
    }

    protected override getStatus(): IStatus {
        const o = this.override;
        return super.getStatus({
            value: o.value == '' ? lm.t(EMPTY_STRING) ?? '' : o.value,
        });
    }

    protected getMoreStatus(): IMoreStatus {
        const o = this.override;
        const display = nsOverride.getSyncfieldOverrideDisplay(o);

        return {
            title: display.translationKey,
            synchronized: o.syncronizedimportfileid
                ? 'status.is synchronized'
                : 'status.is not synchronized',
            what: 'original value',
        };
    }

}
